






export default {
  name: 'Loading',
}
